import { useState } from "react";
import { Star } from "lucide-react";
import { api, fmtError } from "../lib/api";
import { toast } from "sonner";

export const Stars = ({ value = 0, size = "h-3.5 w-3.5" }) => (
  <span className="flex items-center gap-0.5" aria-label={`Note ${value} sur 5`}>
    {[1, 2, 3, 4, 5].map((i) => (
      <Star key={i} className={`${size} ${i <= Math.round(value) ? "fill-amber-500 text-amber-500" : "text-zinc-700"}`} />
    ))}
  </span>
);

export const ReviewForm = ({ track, onDone }) => {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!rating) {
      toast.error("Choisissez une note en étoiles");
      return;
    }
    setBusy(true);
    try {
      await api.post(`/tracks/${track.track_id}/review`, { rating, comment });
      toast.success(`Merci ! Votre avis sur « ${track.title} » sera publié après validation.`);
      onDone?.(rating);
    } catch (e) {
      toast.error(fmtError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex items-center gap-1" data-testid={`review-${track.track_id}`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <button
          key={i}
          onMouseEnter={() => setHover(i)}
          onMouseLeave={() => setHover(0)}
          onClick={() => setRating(i)}
          data-testid={`star-${track.track_id}-${i}`}
          className="p-0.5 transition-transform hover:scale-125"
          title={`${i} étoile${i > 1 ? "s" : ""}`}
        >
          <Star className={`h-4 w-4 ${i <= (hover || rating) ? "fill-amber-500 text-amber-500" : "text-zinc-600"}`} />
        </button>
      ))}
      {rating > 0 && (
        <>
          <input
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            data-testid={`review-comment-${track.track_id}`}
            placeholder="Commentaire (optionnel)"
            className="ml-2 w-40 border border-white/15 bg-transparent px-2 py-1 text-xs outline-none focus:border-amber-500"
          />
          <button
            onClick={submit}
            disabled={busy}
            data-testid={`review-submit-${track.track_id}`}
            className="ml-1 border border-amber-500/60 px-3 py-1 text-[10px] uppercase tracking-[0.15em] text-amber-400 transition-colors hover:bg-amber-500 hover:text-black disabled:opacity-50"
          >
            {busy ? "…" : "Envoyer"}
          </button>
        </>
      )}
    </div>
  );
};
